class ReservationId {
  constructor(private readonly _value: number = NaN) {
  }

  get value() {
    return this._value;
  }
}

export default ReservationId;
